const HYDRATION_NOISE_PATTERNS = [
  /hydration failed because the server rendered html didn't match the client/i,
  /minified react error #418/i,
  /minified react error #423/i,
  /hydration-mismatch/i,
];

const WARNING_PATTERNS = [/^warning:/i];

const normalizeMessage = (message) => {
  if (typeof message === 'string') {
    return message;
  }
  if (message === null || message === undefined) {
    return '';
  }
  return String(message);
};

export const getMessageFromError = (error, fallback = '') => {
  if (error instanceof Error && error.message) {
    return normalizeMessage(error.message);
  }
  if (error && typeof error === 'object' && typeof error.message === 'string') {
    return normalizeMessage(error.message);
  }
  return normalizeMessage(error || fallback);
};

export const isIgnoredDatadogErrorMessage = (message) => {
  const normalized = normalizeMessage(message);
  return HYDRATION_NOISE_PATTERNS.some((pattern) => pattern.test(normalized));
};

export const isWarningDatadogMessage = (message) => {
  const normalized = normalizeMessage(message);
  return WARNING_PATTERNS.some((pattern) => pattern.test(normalized));
};
